import { createGtag } from './google-consent-mode.js';
import { findScript, injectScript, tagUrl, warn } from '../utils.js';

/** Where gtag.js comes from unless `google.gtag.src` points at a first-party endpoint. */
export const GTAG_SRC = 'https://www.googletagmanager.com/gtag/js';

/**
 * Loads gtag.js once and configures every tag ID (GA4 `G-…`, Google Ads `AW-…`, …).
 * The Consent Mode commands are already queued, so the tags start with the right state.
 */
export function loadGtag(win, { ids, dataLayer, src = GTAG_SRC }, { nonce } = {}) {
  const gtag = createGtag(win, dataLayer);
  // Page code expects a global gtag(); never replace one the host already defined.
  if (typeof win.gtag !== 'function') win.gtag = gtag;
  gtag('js', new Date());
  for (const id of ids) gtag('config', id);

  if (findScript(win.document, { id: ids[0], src, pathSuffix: '/gtag/js' })) return;
  injectScript(win.document, tagUrl(src, ids[0], dataLayer), {
    nonce,
    onError: () => warn(`gtag.js failed to load for ${ids[0]}`),
  });
}
